export const MONTH_TRANSLATION_KEYS = [
  "markets.months.jan",
  "markets.months.feb",
  "markets.months.mar",
  "markets.months.apr",
  "markets.months.may",
  "markets.months.jun",
  "markets.months.jul",
  "markets.months.aug",
  "markets.months.sep",
  "markets.months.oct",
  "markets.months.nov",
  "markets.months.dec",
];

export const getMonthLabel = (monthIndex, translate) => {
  const key = MONTH_TRANSLATION_KEYS[monthIndex] || MONTH_TRANSLATION_KEYS[0];
  return translate(key);
};
